// src/pages/Welcome/HeroSection.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { welcomeStyles } from './styles';
import { ArrowRightIcon } from '../../components/Icons';

const HeroSection = ({ user }) => {
  const navigate = useNavigate();

  return (
    <section style={welcomeStyles.hero}>
      <div style={welcomeStyles.heroBackground} />
      <div style={welcomeStyles.heroContent}>
        <h1 style={welcomeStyles.heroTitle}>
          Redbird Markets
        </h1>
        <p style={welcomeStyles.heroSubtitle}>
          The premier marketplace for Illinois State University community. 
          Connect, trade, and thrive in our secure campus marketplace.
        </p>

        {/* Show login/signup buttons if not verified */}
        {(!user || !user.emailVerified) && (
          <div style={welcomeStyles.authButtons}>
            <button 
              onClick={() => navigate('/login')} 
              style={{
                ...welcomeStyles.signInButton,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.background = '#f5f5f5';
                e.target.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.background = '#ffffff';
                e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.2)';
              }}
            >
              <span>Sign In</span>
              <ArrowRightIcon size={18} />
            </button>
            <button 
              onClick={() => navigate('/signup')} 
              style={welcomeStyles.secondaryButton}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                e.target.style.borderColor = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.8)';
              }}
            >
              Create Account
            </button>
          </div>
        )}


      </div>
    </section>
  );
};

export default HeroSection;